module.exports = __webpack_public_path__ + "static/media/Access.973028c6.svg";